import { createSlice } from '@reduxjs/toolkit'

export const lockedBonus = createSlice({
  name: 'lockedBonus',
  initialState: {
    lockedBonus: [],
    BonusAmount: {},
    BonusRules: {},
  },
  reducers: {
    setLockedBonus: (state, action) => ({
      ...state,
      lockedBonus: action.payload,
    }),
    setBonusAmount: (state, action) => ({
      ...state,
      BonusAmount: action.payload,
    }),
    setBonusRules: (state, action) => ({
      ...state,
      BonusRules: action.payload,
    }),
  },
})

export const { setLockedBonus, setBonusAmount, setBonusRules } =
  lockedBonus.actions

export default lockedBonus.reducer
